// ห่อข้อความที่อาจเป็นภาษาขวาไปซ้ายไม่ให้ลากตัวอักษรรอบข้างสลับที่
//
// เลขห้องของภาคศาสนาเป็นอักษรอาหรับ (ا ب ج ...) พอเอาไปต่อกับสิ่งที่ตามหลังในบรรทัด
// เดียวกัน เบราว์เซอร์จะจัดลำดับใหม่ตามกฎ bidi แล้ว "4/ج (2569)" จะขึ้นจอเป็น
// "4/(2569) ج" — ปีไปโผล่กลางป้ายห้อง
//
// FSI (U+2068) ... PDI (U+2069) ทำให้ช่วงนี้เป็นก้อนเดียวที่ตัดสินทิศทางของตัวเอง
// ไม่ลามไปยุ่งกับข้อความรอบๆ ใช้ได้ทั้งใน JSX และใน HTML ที่สั่งพิมพ์ เพราะเป็น
// ตัวอักษรยูนิโค้ด ไม่ใช่แท็กหรือ CSS
export const isolate = (text) => {
  const value = text == null ? '' : String(text)
  return value === '' ? '' : `⁨${value}⁩`
}
